module.exports = __webpack_public_path__ + "static/media/0418ee21.jpg";